import { Buffer } from "buffer";

window.Buffer = window.Buffer || Buffer;
window.global = window.global || window;
